<template>
  <a-spin size="large" :spinning="loading">
    <common-layout>
      <div class="main-login">
        <div class="left" v-if="!isMobile">
          <div class="left-wrap">
            <div class="header">
              <svg-icon iconClass="login" class="logo" style="width: 309px; height: 44px; background: none"></svg-icon>
            </div>
            <div class="left-img">
              <a-carousel autoplay dotsClass="dots">
                <div><img src="@/assets/img/login1.png" /></div>
                <div><img src="@/assets/img/login2.png" /></div>
                <div><img src="@/assets/img/login3.png" /></div>
                <div><img src="@/assets/img/login4.png" /></div>
                <div><img src="@/assets/img/login5.png" /></div>
                <div><img src="@/assets/img/login6.png" /></div>
                <div><img src="@/assets/img/login7.png" /></div>
              </a-carousel>
            </div>
          </div>
        </div>
        <div class="right">
          <div v-if="!loinFail" class="login">
            <div class="title" :class="[lang]">
              {{ isSignUp ? $t("StartTrial") : $t("SignUpTitle") }}
            </div>
            <div class="subTitle" :class="[lang]">
              {{ isSignUp ? $t("try10DaysFree") : $t("SignUpSubTitle") }}
            </div>
            <div class="auth">
              <ul>
                <a-tooltip placement="rightTop" overlayClassName="sign-up-tooltip">
                  <template slot="title" v-if="isSignUp && !isMobile">
                    {{ $t("loginBtnHoverTip") }}
                  </template>
                  <li @click="author('google-oauth2')">
                    <svg-icon iconClass="google"></svg-icon>
                    <span :class="[lang]">{{ $t("SigninwithGoogle") }}</span>
                  </li>
                </a-tooltip>
                <a-tooltip placement="rightTop" overlayClassName="sign-up-tooltip">
                  <template slot="title" v-if="isSignUp && !isMobile">
                    {{ $t("loginBtnHoverTip") }}
                  </template>
                  <li @click="author('linkedin')">
                    <svg-icon iconClass="linkin"></svg-icon>
                    <span :class="[lang]">{{ $t("SigninwithLinkedIn") }}</span>
                  </li>
                </a-tooltip>
                <a-tooltip placement="rightTop" overlayClassName="sign-up-tooltip">
                  <template slot="title" v-if="isSignUp && !isMobile">
                    {{ $t("loginBtnHoverTip") }}
                  </template>
                  <li @click="author('facebook')">
                    <svg-icon iconClass="facebook"></svg-icon>
                    <span :class="[lang]">{{ $t("SigninwithFacebook") }}</span>
                  </li>
                </a-tooltip>
              </ul>
              <div class="orline">
                <span>{{ $t("useEmail") }}</span>
              </div>
              <div class="wrapForm">
                <a-form layout="vertical" :form="form" size="large">
                  <div class="form-label">{{ $t("Email") }}</div>
                  <a-form-item :validate-status="userNameError() ? 'error' : ''" :help="userNameError() || ''"
                    :class="[lang]">
                    <a-input v-decorator="[
                      'userName',
                      {
                        trigger: 'blur',
                        rules: [
                          {
                            required: true,
                            validator: function (rule, value, callback) {
                              let reg =
                                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                              if (
                                !value ||
                                !value.trim('') ||
                                !reg.test(value)
                              ) {
                                // callback($t('rightAccount'));
                                callback($t('rightEmail'));
                                return;
                              }
                              callback();
                            },
                          },
                        ],
                      },
                    ]" :placeholder="$t('Email')">
                      <a-icon slot="prefix" type="mail" style="color: rgba(0, 0, 0, 0.25)" />
                    </a-input>
                  </a-form-item>
                  <div class="form-label">{{ $t("Password") }}</div>
                  <a-form-item :class="[lang]" :validate-status="passwordError() ? 'error' : ''"
                    :help="passwordError() || ''">
                    <a-input-password :placeholder="$t('Password')" v-decorator="[
                      'password',
                      {
                        trigger: ['blur', 'change'],
                        rules: [
                          {
                            required: true,
                            validator: function (rule, value, callback) {
                              // 检查密码长度是否少于 8 个字符
                              if (value.length < 8) {
                                callback($t('charactersDes'));
                                return;
                              }

                              // 检查是否包含大写字母
                              if (!/[A-Z]/.test(value)) {
                                callback($t('uppercaseCharacter'));
                                return;
                              }

                              // 检查是否包含小写字母
                              if (!/[a-z]/.test(value)) {
                                callback($t('lowercaseCharacter'));
                                return;
                              }

                              // 检查是否包含数字
                              if (!/[0-9]/.test(value)) {
                                callback($t('digitRequired'));
                                return;
                              }
                              // 检查是否包含特殊字符
                              if (!reg.test(value)) {
                                callback($t('specialCharacter'));
                                return;
                              }
                              callback();
                            },
                          },
                        ],
                      },
                    ]">
                      <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, 0.25)" />
                    </a-input-password>

                    <div></div>
                  </a-form-item>
                  <div v-if="!isSignUp" style="text-align: left; padding-bottom: 10px">
                    <span @click="resetPwd" class="forgetSkip">{{
                      $t("ForgotPassword")
                      }}</span>
                  </div>

                  <a-form-item>
                    <a-button type="primary" html-type="submit" style="width: 60%" @click="onSubmit" :disabled="hasErrors(form.getFieldsError()) || !haveFormValue()
                      ? true
                      : false
                      ">
                      {{ isSignUp ? $t("createAaccount") : $t("LOGIN") }}
                    </a-button>
                  </a-form-item>
                </a-form>
              </div>
            </div>
            <div class="sign-up-tip" v-if="isSignUp">
              {{ $t("loginTip")
              }}<span @click="changeSignUp()"> {{ $t("loginTipBtn") }}</span>
            </div>
            <div class="sign-up-tip" v-if="!isSignUp">
              {{ $t("createAaccount")
              }}<span @click="tabRegister()"> {{ $t("loginTipBtn") }}</span>
            </div>
            <div class="mobileTips" v-if="isMobile">
              {{ $t("mobileTips") }}
            </div>
          </div>
          <div class="fail" v-if="loinFail">
            <div class="error">
              <svg-icon class="loginError" iconClass="loginError"></svg-icon>
            </div>
            <div class="login-text" :class="[lang]">
              {{ $t("Loginfailed") }}
            </div>
            <div class="eror-code" v-if="loginInfo.msg" :class="[lang]">
              {{ $t("Errorcode") }}：{{ loginInfo.msg }}
            </div>
            <div class="eror-code" v-if="showError" :class="[lang]">
              {{ $t("authorization") }}
            </div>
            <div class="retry" :class="[lang]">{{ $t("Youcantry") }}</div>
            <div class="btn relogin" :class="[lang]" @click="reLogin">
              <svg-icon class="icon" iconClass="restart-line"></svg-icon>{{ $t("Logagain") }}
            </div>
            <div class="btn concatus">
              <a href="https://tawk.to/chat/67626c9aaf5bfec1dbddbfc4/1ifc7gf7c" target="_blank"
                :class="[lang]"><svg-icon class="icon" iconClass="concat"></svg-icon>{{ $t("Emailus") }}</a>
            </div>
            <div class="wrap-code">
              <div class="qrcode">
                <img src="https://u-img.strategybrain.ca/images/static/linkedIn.jpg" />
                <div class="text">
                  <span>Linkedln</span>
                </div>
              </div>
              <div class="qrcode">
                <img src="https://u-img.strategybrain.ca/images/static/whatsapp.jpg" />
                <div class="text">
                  <span>Whats App</span>
                </div>
              </div>
            </div>
            <div class="qus" :class="[lang]">{{ $t("problem") }}</div>
          </div>
        </div>
      </div>
      <a-modal v-model="showModal" :maskClosable="false" :title="$t('verificationCode')" on-ok="handleOk"
        @cancel="handleCancel">
        <template slot="footer">
          <div style="text-align: center">
            <a-button key="submit" type="primary" :disabled="hasErrors(form2.getFieldsError()) || !haveForm2Value()
              ? true
              : false
              " @click="handleOk">
              {{ $t("Submit") }}
            </a-button>
          </div>
        </template>
        <div class="wrapForm2">
          <p :class="[lang]">
            {{ $t("digitVerification").replace("xxxxx", formData.userName) }}
          </p>
          <a-form layout="vertical" :form="form2" size="large">
            <!-- 其他表单项 -->
            <a-form-item class="codeForm" :validate-status="codeError() ? 'error' : ''" :help="codeError() || ''">
              <a-input v-decorator="[
                'verificationCode',
                {
                  trigger: ['blur', 'change'],
                  rules: [
                    {
                      required: true,
                      validator: function (rule, value, callback) {
                        let reg = /^[0-9]{6}$/;
                        if (!value || !value.trim('') || !reg.test(value)) {
                          callback($t('invalidCode'));
                          return;
                        }
                        callback();
                      },
                    },
                  ],
                },
              ]" />
              <span class="time" v-if="countdown > 0">
                {{ countdown + "s" }}
              </span>
              <span class="time time2" @click="sendVerificationCode" v-else>
                {{ $t("Resend") }}
              </span>
            </a-form-item>
            <!-- 其他表单项 -->
          </a-form>
        </div>
      </a-modal>
      <div class="mask" v-show="visiable">
        <div class="dialog">
          <div class="loading">
            <img src="@/assets/img/login_loading.gif" />
          </div>
          <div class="text" :class="[lang]">{{ $t("loadingSpace") }}..</div>
          <div class="slide-wrap">
            <a-carousel autoplay dotsClass="dots">
              <div class="dtext" :class="[lang]">
                {{ $t("Afterlogging") }}
              </div>
              <div class="dtext" :class="[lang]">
                {{ $t("Whencreating") }}
              </div>
              <div class="dtext" :class="[lang]">
                {{ $t("Youcancreate") }}
              </div>
              <div class="dtext" :class="[lang]">
                {{ $t("Settingsearch") }}
              </div>
              <div class="dtext" :class="[lang]">
                {{ $t("Themore") }}
              </div>
              <div class="dtext" :class="[lang]">
                {{ $t("Enteras") }}
              </div>
              <div class="dtext" :class="[lang]">
                {{ $t("ForLinkedIn") }}
              </div>
            </a-carousel>
          </div>
        </div>
      </div>
    </common-layout>
  </a-spin>
</template>

<script>
import CommonLayout from "@/layouts/CommonLayout";
// import { login } from "@/services/user";
import { setAuthorization } from "@/utils/request";
// import { loadRoutes } from "@/utils/routerUtil";
import { mapMutations } from "vuex";
// import { useAuth0 } from "@auth0/auth0-vue";
// const auth0 = useAuth0();
import { sendData } from "@/utils/burying-point";
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
export default {
  name: "Login",
  components: { CommonLayout },
  data() {
    return {
      showModal: false,
      hasErrors,
      reg: /[!@#$%^&*(),".?:{}|<>]/,
      labelPosition: "right",
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      //倒计时
      countdown: 0,
      formData: {},
      loginInfo: {},
      loinFail: false,
      visiable: false,
      logging: false,
      isAuthenticated: false,
      isLoading: false,
      error: "",
      loading: false,
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      showPage: false,
      showError: false,
      timer: null,
      isSignUp: false, // 是否注册
      // cloundfauture code
      turnstileToken: null,
      aff: 0,
      isLikeMobile: false,
    };
  },

  computed: {
    systemName() {
      return this.$store.state.setting.systemName;
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
      );
      return flag;
    },
  },
  i18n: require("./i18n"),
  created() {
    // this.initTurnstile();
    let { aff } = this.$route.query;
    if (aff) {
      this.aff = aff;
      localStorage.setItem("aff", aff);
    }
  },
  mounted() {
    const auto_buy = this.$route.query["auto-buy"];
    if (auto_buy) {
      localStorage.setItem("auto_buy", auto_buy);
    }
    this.timer = setInterval(() => {
      if (window.Tawk_API && window.Tawk_API.shutdown) {
        window.Tawk_API && window.Tawk_API.shutdown();
        clearInterval(this.timer);
      }
    }, 200);

    // 数据上报
    sendData({
      event_name: "vist_login",
    });
    if (localStorage.getItem("token")) {
      this.$router.push("/sales/salesReps");
      return;
    }
    if (location.hash.indexOf("access_denied") > -1) {
      // 授权失败
      sendData({
        event_name: "loginskip_cancel",
      });
      this.showError = true;
      this.loinFail = true;
      return;
    } else {
      this.showError = false;
    }
    if (location.hash.indexOf("access_token") != -1) {
      // 授权成功
      this.visiable = true;
      sendData({
        event_name: "loginskip_accecpt",
      });
      let aff = localStorage.getItem("aff");
      this.$axios(
        "/user/login",
        {
          aff,
          auth0_token: location.hash.split("=")[1].split("&")[0],
        },
        "post",
      ).then((res) => {
        if (res.code == "200") {
          this.getUserInfo(res);
        } else {
          sessionStorage.removeItem("token");
          this.loginInfo = res || {};
          this.loinFail = true;
          // this.$message.error(res.msg);
        }
      });
    }
    if (this.isMobile) {
      document.querySelector("#popContainer").style.minWidth = "100vw";
    } else {
      document.querySelector("#popContainer").style.minWidth = "1200px";
    }
  },
  methods: {
    initTurnstile() {
      if (window.turnstile) {
        this.turnstileWidget = window.turnstile.render("#example-container", {
          sitekey: "1x00000000000000000000AA",
          language: this.lang == "AR" ? "ar" : this.lang == "CN" ? "zh" : "en",
          callback: (token) => {
            this.turnstileToken = token;
          },
        });
      }
    },
    //获取用户信息
    getUserInfo(res) {
      localStorage.setItem("token", res.data.access_token);
      localStorage.setItem("StrategyBrainLoginSuccess", true);
      setAuthorization({
        token: res.data.access_token,
        expireAt: new Date("2099/12/30 23:59:59"),
      });
      this.$axios(
        "/user/info",
        {
          auto_buy: localStorage.getItem("auto_buy")
            ? parseInt(localStorage.getItem("auto_buy"))
            : null,
        },
        "post",
      ).then((res2) => {
        if (res2.code == 200) {
          if (window.fbq) {
            window.fbq("track", "CompleteRegistration");
          }

          this.setUser({
            ...res2.data,
          });
          this.getGuideProgress();
          let { sales_has_published_campaign, recruiter_has_published_campaign, saleEndCapaignDate, hrEndCapaignDate } = res2.data;
          if (!sales_has_published_campaign && !recruiter_has_published_campaign) {
            this.$router.push({
              path: "/guide/enter",
              query: {
                isNew: res.data.is_new == false ? 0 : 1,
                campaign_type: 2,
              },
            });

            // this.$router.push({
            //   path: "/consultation/enter",
            //   query: {
            //     isNew: res.data.is_new == false ? 0 : 1,
            //     campaign_type: 2,
            //   },
            // });
          } else if (saleEndCapaignDate && hrEndCapaignDate) {
            if (
              new Date(saleEndCapaignDate).getTime() >
              new Date(hrEndCapaignDate).getTime()
            ) {
              this.$router.push("/sales/salesReps/home");
            } else {
              this.$router.push("/sales/salesReps/home");
            }
          } else {
            this.$router.push("/sales/salesReps/home");
          }
        }
      });
    },

    handleCancel() {
      this.form2.resetFields();
    },

    // 邮箱验证码成功后开始进行注册
    handleOk() {
      this.form2.validateFields((err, values) => {
        if (!err) {
          let obj = values;
          this.visiable = true;
          let aff = localStorage.getItem("aff");
          this.$axios(
            "/user/reg_by_email",
            {
              email_code: obj.verificationCode,
              email: this.formData.userName,
              password: this.formData.password,
              cf_token: this.turnstileToken,
              aff,
            },
            "post",
          ).then((res) => {
            this.form2.resetFields();
            if (res.code == 200) {
              this.getUserInfo(res);
              this.showModal = false;
            } else {
              this.visiable = false;
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    resetPwd() {
      this.writeLog("sign_in", "page_click", "log_in");
      this.$router.push({ path: "/resetPwd" });
    },
    loginByEmail() {
      this.writeLog("sign_in", "page_click", "log_in");
      this.visiable = true;
      return new Promise((resolve, reject) => {
        let aff = localStorage.getItem("aff");
        this.$axios(
          "/user/login_by_email",
          {
            email: this.formData.userName,
            password: this.formData.password,
            aff,
          },
          "post",
        ).then((res) => {
          if (res.code == 200) {
            resolve("login success");
            this.getUserInfo(res);
          } else {
            this.loginInfo = res || {};

            this.visiable = false;
            reject(res.msg);
          }
        });
      });
    },
    onSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // 获取 Turnstile Token
          // 注册
          if (this.isSignUp) {
            let input = document
              .querySelector("#example-container")
              .querySelector('input[name="cf-turnstile-response"]');
            this.turnstileToken = input ? input.value : "";
            if (!this.turnstileToken) {
              this.$message.error(this.$t("humanValid"));
              return;
            }
            this.formData = values;
            this.loading = true;
            this.sendVerificationCode()
              .then(() => {
                this.showModal = true;
                this.loading = false;
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            //登录
            this.formData = values;
            this.loginByEmail();
          }

          // this.logging = true;
          // const name = this.form.getFieldValue("userName");
          // const password = this.form.getFieldValue("password");
          // login(name, password, turnstileToken).then(this.afterLogin);
        }
      });
    },
    userNameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("userName") && getFieldError("userName");
    },
    getPasswordValue() {
      const { getFieldValue } = this.form;
      return getFieldValue("password");
    },
    haveForm2Value() {
      const { getFieldValue } = this.form2;
      return getFieldValue("verificationCode") ? true : false;
    },
    haveFormValue() {
      const { getFieldValue } = this.form;
      return getFieldValue("password") && getFieldValue("userName")
        ? true
        : false;
    },
    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("password") && getFieldError("password");
    },
    codeError() {
      const { getFieldError, isFieldTouched } = this.form2;
      return (
        isFieldTouched("verificationCode") && getFieldError("verificationCode")
      );
    },
    reLogin() {
      this.loinFail = false;
    },
    sendVerificationCode() {
      // 这里可以添加发送验证码的逻辑
      // 假设发送验证码成功后开始倒计时
      return new Promise((resolve, reject) => {
        this.$axios(
          "/user/send_email_code",
          {
            email: this.formData.userName,
          },
          "post",
        ).then((res) => {
          if (res.code == 200) {
            resolve();
            this.countdown = 60; // 设置倒计时时间为60秒
            const interval = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown--;
              } else {
                clearInterval(interval);
              }
            }, 1000);
          } else {
            reject();
          }
        });
      });
    },
    author(op) {
      this.loading = true;
      let event_name = "login_button_google";
      switch (op) {
        case "google-oauth2":
          event_name = "login_button_google";
          this.writeLog("sign_in", "page_click", "google");
          break;
        case "facebook":
          event_name = "login_button_facebook";
          this.writeLog("sign_in", "page_click", "facebook");
          break;
        case "linkedin":
          event_name = "login_button_linkedin";
          this.writeLog("sign_in", "page_click", "linkedin");
          break;
      }

      sendData({
        event_name,
      });
      this.webAuth.authorize(
        {
          responseType: "token",
          connection: op,
          // redirectUri: "http://localhost:8080/login",
          redirectUri: process.env.VUE_APP_SKIP_BASE_URL,
          // authorizationParams: {
          //   redirect_uri: "http://localhost:8080/login",
          // },
        },
        (err, authResult) => {
          console.log(err, authResult);
          this.loading = false;
          //do something
        },
      );
    },
    ...mapMutations("account", ["setUser", "setPermissions", "setRoles"]),
    // onSubmit(e) {
    //   e.preventDefault();
    //   this.form.validateFields((err) => {
    //     if (!err) {
    //       this.logging = true;
    //       const name = this.form.getFieldValue("name");
    //       const password = this.form.getFieldValue("password");
    //       login(name, password).then(this.afterLogin);
    //     }
    //   });
    // },
    afterLogin(res) {
      this.logging = false;
      const loginRes = res;
      if (loginRes.code >= 0) {
        const { user, permissions, roles } = loginRes.data;
        this.setUser(user);
        this.setPermissions(permissions);
        this.setRoles(roles);
        setAuthorization({
          token: loginRes.data.token,
          expireAt: new Date(loginRes.data.expireAt),
        });
        this.$router.push("/sales/salesReps");
        this.$message.success(loginRes.message, 3);
        // 获取路由配置
        // getRoutesConfig().then((result) => {
        //   ;
        //   const routesConfig = result.data.data;
        //   console.log("routesConfig", routesConfig);
        //   alert(3);
        //   ;
        //   loadRoutes(routesConfig);
        //   alert(333);
        //   ;
        //   //this.$router.push("/sales/salesReps");
        //   this.$message.success(loginRes.message, 3);
        // });
      } else {
        this.error = loginRes.message;
      }
    },
    onClose() {
      this.error = false;
    },
    changeSignUp() {
      this.isSignUp = false;
    },
    resetTurnstile() {
      if (this.turnstileWidget) {
        window.turnstile.reset(this.turnstileWidget);
      }
    },
    tabRegister() {
      this.writeLog("sign_in", "page_click", "click_here");
      localStorage.removeItem("StrategyBrainLoginSuccess");
      this.$router.push("/signUp");
    },
  },
  beforeDestroy() {
    document.querySelector("#popContainer").style.minWidth = "1200px";
  },
};
</script>

<style lang="less" scoped>
.mask {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;

  .dialog {
    width: 746px;
    height: 576px;
    background: #ffffff;
    border-radius: 21px 21px 21px 21px;

    .loading {
      text-align: center;
      padding-top: 70px;

      img {
        height: 246px;
      }
    }

    .text {
      text-align: center;
      padding-top: 27px;
      font-weight: bold;
      font-size: 36px;
      color: #000000;
      padding-bottom: 27px;
    }

    .slide-wrap {
      // width: 704px !important;
      margin: 0 auto;
      height: 42px;

      .dtext {
        text-align: center;
      }

      /deep/.ant-carousel {
        // width: 704px !important;
        height: 42px;

        .slick-list {
          height: 64px;
        }
      }

      .ant-carousel .slick-slide {
        text-align: center;
        height: 160px;
        line-height: 160px;
        background: #364d79;
        overflow: hidden;
      }

      .ant-carousel .slick-slide h3 {
        color: #fff;
      }

      /deep/ .ant-carousel .slick-dots-bottom {
        bottom: -12px !important;
        height: 10px;
      }

      /deep/ .ant-carousel .slick-dots li button {
        width: 9px;
        height: 9px;
        background: #b8d1ce;
        border-radius: 50%;
        opacity: 1;
      }

      /deep/ .ant-carousel .slick-dots .slick-active button {
        width: 29px;
        height: 9px;
        background: #0e756a;
        border-radius: 4px;
      }
    }
  }

  @media screen and (max-width: 1680px) {
    .dialog {
      zoom: 0.8;
    }
  }
}

/deep/.content {
  padding: 0 !important;
}

.common-layout {
  .main-login {
    height: 100vh;
    display: flex;

    .left,
    .right {
      flex: 1;
      height: 100vh;
    }

    .right {
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .left {
      background: url(../../assets/img/left_login_bg.png) no-repeat;
      background-size: 100% 100%;

      .left-wrap {
        .header {
          position: fixed;
          top: 40px;
          left: 40px;
        }

        .left-img {
          width: 100%;
          height: 100vh;
          position: relative;
        }

        .ant-carousel {
          width: 654px;
          height: 420px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);

          img {
            width: 654px;
            height: 420px;
          }
        }

        @media screen and (max-width: 1680px) {
          .ant-carousel {
            width: 523px;
            height: 336px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);

            img {
              width: 523px;
              height: 336px;
            }
          }
        }

        .ant-carousel .slick-slide {
          text-align: center;
          height: 160px;
          line-height: 160px;
          background: #364d79;
          overflow: hidden;
        }

        .ant-carousel .slick-slide h3 {
          color: #fff;
        }

        /deep/ .ant-carousel .slick-dots-bottom {
          bottom: -12px !important;
          height: 10px;
        }

        /deep/ .ant-carousel .slick-dots li button {
          width: 9px;
          height: 9px;
          background: #b8d1ce;
          border-radius: 50%;
          opacity: 1;
        }

        /deep/ .ant-carousel .slick-dots .slick-active button {
          width: 29px;
          height: 9px;
          background: #0e756a;
          border-radius: 4px;
        }
      }
    }
  }

  .top {
    text-align: center;

    .header {
      height: 68px;
      line-height: 44px;

      a {
        text-decoration: none;
      }

      .logo {
        width: auto;
        height: 44px;
        vertical-align: top;
      }

      .title {
        font-size: 33px;
        color: @title-color;
        font-family: "Myriad Pro", "Helvetica Neue", Arial, Helvetica,
          sans-serif;
        font-weight: 600;
        position: relative;
        top: 2px;
      }

      .subTitle {}
    }

    .desc {
      font-size: 14px;
      color: @text-color-second;
      margin-top: 12px;
      margin-bottom: 40px;
    }
  }

  .login {
    text-align: center;

    .title {
      font-family: Arial, Arial;
      font-weight: bold;
      font-size: 34px;
      color: #0e756a;
      text-align: center;
      line-height: 40px;
    }

    .subTitle {
      margin-top: 8px;
      font-family: Arial, Arial;
      font-weight: bold;
      font-size: 16px;
      color: #ff7810;
      text-align: center;
      background: #fff3db;
      border-radius: 4px 4px 4px 4px;
      line-height: 20px;
      padding: 8px 30px;
      display: inline-block;
    }

    .auth {

      ul,
      li {
        padding: 0;
        margin: 0;
        list-style: none;
      }

      ul {
        width: 390px;
        margin: 0 auto;
        margin-top: 20px;
      }

      li {
        cursor: pointer;
        margin-bottom: 16px;
        width: 390px;
        height: 44px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #d9d9d9;
        line-height: 42px;
        text-align: center;

        span {
          display: inline-block;
          margin-left: 10px;
          font-weight: bold;
          font-size: 16px;
          color: #000000;
        }

        &:hover {
          box-shadow: 0px 3px 6px 1px rgba(14, 117, 106, 0.2);
          border: 2px solid #0e756a;
        }

        .svg-icon {
          font-size: 20px;
        }
      }
    }

    .sign-up-tip {
      font-weight: bold;
      font-size: 14px;
      color: #000000;
      line-height: 20px;
      text-align: center;

      span {
        color: #1b7c72;
        cursor: pointer;
      }
    }

    .forget {
      font-family: Arial, Arial;
      font-weight: 400;
      font-size: 12px;
      color: #0e756a;
      cursor: pointer;
      margin-top: 30px;
      text-align: center;
    }

    // width: 100%;

    // background: #ffffff;
    // box-shadow: 0px 10px 20px 1px rgba(0, 0, 0, 0.1);
    // border-radius: 21px 21px 21px 21px;
    // margin: 0 auto;
    padding: 30px 20px;

    // @media screen and (max-width: 576px) {
    //   padding: 60px 0;
    // }
    // @media screen and (max-width: 320px) {
    //   .captcha-button {
    //     font-size: 14px;
    //   }
    // }
    .wrap-login {
      width: 360px;
      margin: 0 auto;
      margin-top: 42px;
    }

    .icon {
      font-size: 24px;
      color: @text-color-second;
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: @primary-color;
      }
    }
  }

  .noHave {
    font-family: Arial, Arial;
    font-weight: 400;
    font-size: 18px;
    text-align: center;
    margin-top: 34px;
  }

  .forget,
  .reg {
    color: #0e756a;
    text-decoration: underline;
    text-align: center;
  }
}

.fail {
  .error {
    text-align: center;

    .loginError {
      width: 38px;
      height: 34px;
    }
  }

  .login-text {
    text-align: center;
    margin-top: 8px;
    margin-bottom: 13px;
    font-weight: bold;
    font-size: 24px;
    color: #000000;
  }

  .eror-code {
    font-weight: bold;
    font-size: 16px;
    color: #999999;
    text-align: center;
  }

  .retry {
    font-weight: bold;
    font-size: 18px;
    color: #000000;
    margin-top: 65px;
    text-align: center;
  }

  .btn {
    width: 410px;
    height: 66px;
    line-height: 66px;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 2px solid #0e756a;
    margin-top: 27px;
    text-align: center;
    cursor: pointer;

    .icon {
      margin-right: 10px;
    }
  }

  .relogin {
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
    background: #0e756a;
  }

  .concatus {
    font-weight: bold;
    font-size: 20px;
    color: #0e756a;
  }

  .wrap-code {
    width: 362px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .qrcode {
      width: 144px;
    }

    img {
      display: block;
      width: 122px;
      margin: 0 auto;
      margin-top: 56px;
    }

    .text {
      margin-top: 11px;
      text-align: center;
      width: 144px;
      font-weight: bold;
      font-size: 14px;
      color: #000000;
      width: 144px;
      height: 31px;
      line-height: 31px;
      background: #eff0f0;
    }
  }

  .qus {
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    margin-top: 32px;
    text-align: center;
  }
}

@media screen and (max-width: 1680px) {
  .fail {
    position: relative;
    transform: scale(0.7);
  }

  // .right .login {
  //   transform: scale(0.9);
  // }
}

@media screen and (max-width: 768px) {
  .mask {
    .dialog {
      max-width: 95%;
      zoom: 0.6;
    }

    .dtext {
      padding: 0 20px;
    }
  }

  .fail {
    position: relative;
    transform: scale(0.5);
  }

  .right {
    max-width: 100%;

    .login {
      zoom: 0.8;
    }
  }
}

@media screen and (min-width: 768px) {
  .mask .slide-wrap {
    width: 704px !important;

    /deep/.ant-carousel {
      width: 704px !important;
    }
  }
}

@media screen and (max-width: 480px) {
  .mask .dialog {
    zoom: 0.5;
  }

  .right {
    .login {
      zoom: 0.7;
    }
  }
}
</style>
<style lang="less" scoped>
.ant-tooltip.sign-up-tooltip {
  max-width: 262px;

  .ant-tooltip-inner {
    background: #496a5b;
    padding: 14px;
    border-radius: 6px;
    line-height: 22px;
    font-size: 14px;
    color: #fff;
  }

  .ant-tooltip-arrow {
    top: 9px;

    &::before {
      background: #496a5b;
      width: 10px;
      height: 10px;
    }
  }
}

.wrapForm {
  width: 390px;
  margin: 0 auto;
}

.wrapForm2 {
  .codeForm {
    position: relative;

    .time {
      position: absolute;
      right: 10px;
      top: -3px;
    }

    .time2 {
      cursor: pointer;
      color: #1b7c72;
    }
  }
}

.orline {
  margin: 10px 0px;
  text-align: center;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-align: center;
  align-items: center;
  width: 455px;
  margin: 0 auto;
  gap: 1.5rem;
  // text-transform: uppercase;
  font-size: 14px;
  line-height: 1.8rem;
  color: rgb(140, 146, 156);

  span {}
}

.orline::before,
.orline::after {
  content: "";
  display: inline-block;
  border-top: 0.1rem solid rgb(227, 229, 231);
  -webkit-box-flex: 1;
  flex-grow: 1;
}

/deep/.ant-input-affix-wrapper {
  .ant-input {
    height: 42px;
  }
}

.cf-turnstile {
  width: 100%;
  margin-bottom: 12px;
}

/deep/.ant-form-explain {
  text-align: left;
}

/deep/.ant-form-item {
  margin-bottom: 8px;
}

.form-label {
  text-align: left;
  margin-bottom: 4px;
}

.info-tips {
  padding-top: 5px;
  color: rgba(0, 0, 0, 0.35);
  text-align: left;
  font-size: 12px;
}

.forgetSkip {
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
}

.forgetSkip:hover {
  color: #1b7c72;
}

.mobileTips {
  display: none;
}

@media screen and (max-width: 768px) {
  .mobileTips {
    display: block;
    color: red;
    font-size: 12px;
    text-align: center;
    margin-top: 10px;
  }

  .mask .dialog {
    zoom: 0.5;
  }

  .right {
    .login {
      zoom: 0.7;
    }
  }
}
</style>
